import React from "react";
import { NavLink } from "react-router-dom";
import MenuMount from "./MenuMount";
import MenuButton from "./MenuButton";

const Navbar = ({ nav, set }) => {
  const tabList = [{path:"", title:"Home"}, {path:"About", title:"About Us"}, {path:"Services", title:"Services"}, {path:"Gallery", title:"Gallery"}, {path:"Contact", title:"Contact Us"}];

  const tabs = tabList.map((item, i) => {
    return (
      <NavLink exact to={`/${item.path}`} key={item.title} activeClassName="active-nav-link" className="nav-link" onClick={() => {set(false)}}>
        {item.title}
      </NavLink>
    );
  });

  return (
    <nav className="navbar">
      <NavLink to="" className="logo">
        <p className="larger">IPWD|</p>
        <p>InterPerfect <br/>Windows and Doors</p>
      </NavLink>
      <ul className="nav-large">{tabs}</ul>
    
      <MenuButton toggle={nav} setButton={set}/>
      <MenuMount nav={nav} tabs={tabs} />
    </nav>
  );
};

export default Navbar;
